import { useEntityPage } from "../useEntityPage";
import { automationTypeOptions } from "./automationTypeOptions";

/** A saved automation's type as text, with what the type means beneath it. */
export function AutomationTypeSummary() {
  const { record } = useEntityPage();
  const type = automationTypeOptions.find(
    (option) => String(option.value) === String(record?.type)
  );

  return (
    <div>
      <p className="fw-semibold mb-1">{type?.label ?? "--"}</p>
      {type && <p className="small text-body-secondary mb-0">{type.description}</p>}
    </div>
  );
}

export default AutomationTypeSummary;
